import { appendPulseTrackingToEvents } from './pulse';
import { pulseObject } from './pulse/helpers';
import { debug, handleRedirect, isUrl } from './utils';
import { appendSentryEvents } from './sentry/index';

export function setupPsiConfig(_window, _document, _navigator, config, type) {
    if (!config || !config.baseEndpoint || !config.propertyId || !config.consentLanguage) {
        throw new Error('One of missing: baseEndpoint, propertyId, consentLanguage');
    }

    appendPulseTrackingToEvents(_window, config);
    appendSentryEvents(config);

    config.accountId = config.accountId || 1047;
    // empty object should be assigned to make Custom Messages work
    config.custom = {};

    config.gdpr = { includeTcfApi: type === 'tcf' };
    
    if (config.propertyHref) config.joinHref = true;
    if (config.userId) setTargetingParams('loggedin', 'true');

    const mobileWebViewUa = ['Hermes', '_app_', 'tv.nu', 'FinnApp', 'Omni'];

    function getTargetingParamsFromCookie() {
        const cookieNamePattern = /(_sch_cmp_[_a-z0-9]+)=(.+)/i;
        const matches = _document.cookie
            .split(';')
            .filter((it) => cookieNamePattern.test(it))
            .map((it) => it.split('=').map((it) => it.trim()));
        matches.forEach(([name, value]) => setTargetingParams(name, value));
    }

    function setTargetingParams(key, val) {
        config.targetingParams = config.targetingParams || {};
        config.targetingParams[key] = val;
    }

    // targeting parameter for webview
    const isWebView = mobileWebViewUa.some((webviewAgent) => _navigator.userAgent.includes(webviewAgent));
    if (isWebView) {
        setTargetingParams('mobile-webview', config.showInWebview ? config.showInWebview : true)
    }

    const ref = _document?.referrer?.split('/')[2];
    if (ref) {
        setTargetingParams('referrer-hostname', ref);
    }
    getTargetingParamsFromCookie();

    const setUserId = function (id) {
        if (typeof id === 'number' || id === undefined) {
            return config.userId = id;
        }

        throw new Error(`Id value ${id} is invalid`);
    };

    const openPrivacySettings = function (url) {
        if (!isUrl(url)) {
            return console.error('The URL passed to the configuration is invalid. Please, correct it.');
        }

        if (!config.userId) {
            return pulseObject(window, (sdk) => {
                sdk.getEnvironmentId().then((environmentId) => {
                    handleRedirect(
                        url,
                        environmentId,
                        config.clientId,
                        config.referrer,
                        config.state
                    );
                });
            });
        }

        return handleRedirect(url, null, config.clientId, config.referrer, config.state);
    };

    if (
        config.propertyHref &&
        _document.location.search &&
        config.propertyHref.indexOf('?') === -1
    ) {
        config.propertyHref += _document.location.search;
    }
    const {
        jsSdkVersion,
        id,
        realm,
        clientId,
        pulseTracker,
        referrer,
        state,
        pulseObjectName,
        showInWebview,
        ...spConfig
    } = config;
    _window._sp_ = _window._sp_ || {};
    _window._sp_.config = spConfig;
    debug('Sourcepoint initiated with config: ', spConfig);

    _window.psi = _window.psi || {};
    _window.psi.setUserId = setUserId;
    _window.psi.openPrivacySettings = openPrivacySettings;
    _window.psi.pulseTracker = pulseTracker;
    _window.psi.clientId = clientId;
    _window.psi.referrer = referrer;
    _window.psi.state = state;
    _window.psi.pulseObjectName = pulseObjectName;
    _window.psi.showInWebview = showInWebview;
}
